import { render, staticRenderFns } from "./CustomButtonModal.vue?vue&type=template&id=39e999d0&scoped=true"
import script from "./CustomButtonModal.vue?vue&type=script&lang=ts"
export * from "./CustomButtonModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomButtonModal.vue?vue&type=style&index=0&id=39e999d0&prod&scoped=true&lang=css"
import style1 from "./CustomButtonModal.vue?vue&type=style&index=1&id=39e999d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e999d0",
  null
  
)

export default component.exports